import { createFileRoute, Link } from "@tanstack/react-router";
export const Route = createFileRoute("/thank-you")({
  head: () => ({ meta: [{ title: "Thank You · Buddha KA" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <section className="mx-auto max-w-2xl px-4 py-24 text-center sm:px-6">
      <div className="mx-auto h-24 w-24 halo animate-halo rounded-full" />
      <p className="mt-8 text-xs uppercase tracking-[0.3em] text-gold">Received</p>
      <h1 className="mt-4 font-serif text-4xl sm:text-5xl">Thank you.</h1>
      <p className="mt-4 text-muted-foreground">The exchange is complete. Carry the work forward.</p>
      <Link to="/" className="mt-8 inline-flex rounded-full bg-gold-gradient px-5 py-2.5 text-sm font-semibold text-obsidian">Return home</Link>
    </section>
  ),
});
